import React from 'react'

import {SectionTrackerProvider} from '../SectionTracker'
import {AllFiltersPopoverContent} from './AllFiltersPopoverContent'

export const AllFiltersPopover = () => {
  return (
    <SectionTrackerProvider>
      <AllFiltersPopoverContent />
    </SectionTrackerProvider>
  )
}
